import React from 'react';

import { CountryCode } from '@/i18n/countries';
import { LanguageCode } from '@/i18n/languages';

interface BaseProps {
    icon: `country-${CountryCode}` | `lang-${LanguageCode}`;
    sizeSm?: number;
    sizeMd?: number;
    className?: string;
    iconClass?: string;
    testId?: string;
}

type WithText = { text: string; ariaLabel?: string };
type IconOnly = { text?: string; ariaLabel: string };

type Props = BaseProps & (WithText | IconOnly);

export default function IconFlag({ sizeSm = 4, sizeMd = 6, className = '', iconClass = '', ...props }: Props) {
    return (
        <div className={`flex w-auto items-center gap-x-2 ${className}`}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                src={`/assets/icons/flags/${props.icon}.svg`}
                alt={props.ariaLabel}
                className={`h-${sizeSm ?? 4} w-${sizeSm ?? 4} md:h-${sizeMd ?? 6} md:w-${sizeMd ?? 6} ${iconClass}`}
                draggable="false"
            />
            {props.text && <span className="md:text-regular text-sm">{props.text}</span>}
        </div>
    );
}
